import { DISABLE_CHOICE_RANDOMIZATION } from '../../../../containers/project/polls/PollUtils';
import CheckboxInputField from '../checkboxInputField/CheckboxInputField';

export { DISABLE_CHOICE_RANDOMIZATION };

export default function PreventRandomizationCheckbox(props) {
  const { question } = props;

  return (
    <CheckboxInputField
      id={`checkbox-randomize-choices-${question._id}`}
      type='checkbox'
      fieldName={DISABLE_CHOICE_RANDOMIZATION}
      fieldClass='l-form__item'
      label='Ordering choices'
      labelTooltip='Choices can be present to respondents in a random order, or in the order they appear on the screen.'
      isToggle={true}
      checkedLabel='Choices are shuffled'
      uncheckedLabel='Choices are in order'
      hideLabel={false}
    />
  );
}
